import { NotFoundError } from "@hm/fundamental"
import { useAuth } from "@shared/lib/auth"
import { getDefaultRouteByPermissions } from "@shared/lib/auth/utils/getDefaultRouteByPermissions"
import { useTraceparent } from "@shared/lib/hooks"
import { CentralizedContainerBox, TraceIdBadge } from "@shared/ui"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export const NotFoundPage: React.FC = () => {
	const { t } = useTranslation("pages", { keyPrefix: "notFound" })
	const navigate = useNavigate()
	const { traceId } = useTraceparent()
	const { userPermissions } = useAuth()
	const defaultRoute = getDefaultRouteByPermissions(userPermissions)

	const handlePageOpen = () => {
		navigate(defaultRoute)
	}

	return (
		<CentralizedContainerBox data-cy="not-found-page-container">
			<div className="flex flex-col items-center">
				<NotFoundError
					title={t("title")}
					description={t("description")}
					className="!h-auto !pb-6"
					pageOpenText={t("secondaryButtonTitle", {
						page: defaultRoute.replace("/", ""),
					})}
					onPageOpen={handlePageOpen}
					data-cy="not-found-error"
				/>
				<TraceIdBadge traceId={traceId} data-cy="not-found-trace-id" />
			</div>
		</CentralizedContainerBox>
	)
}
